import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { observe } from 'projects/web/src/util/loading/loading';
import { Host } from '@interfaces/host';
import { CompanyService } from '@services/company.service';
import { access } from '@util/route/access';

@Injectable({
  providedIn: 'root'
})
export class CompanyResolverService implements Resolve<Host.Company> {
  constructor(private companyService: CompanyService) {
  }
  
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Host.Company> {
    const companyId = access(route).param('companyId');
    const request = companyId
      ? observe(this.companyService.get(companyId))
      : this.companyService.self();
    return request.pipe(
      catchError((error) => {
        if (!state.url.includes('/availability')) return throwError(error);
        console.error('Ruby company call failed while opening availability', error);
        const fallback = this.companyFromSession();
        return fallback ? of(fallback) : throwError(error);
      })
    );
  }

  private companyFromSession(): Host.Company | null {
    try {
      const stored = this.companyService.loadFromStorage();
      return stored?.id ? stored : null;
    } catch (error) {
      console.error('Unable to read the company saved at login', error);
      return null;
    }
  }
}
